import { InfoIconButton } from '@screens/checkout/delivery/components/PickUpOptions.styles';
import {
  InsuranceInfoDiv,
  InsuranceInfoTypography,
} from './InsuranceInfo.styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface InsuranceInfoProps {
  productsWithInsuranceQuantity: number;
  orderDetailsAmount: number;
  payAmount: number;
}

export const InsuranceInfo = ({
  productsWithInsuranceQuantity,
  orderDetailsAmount,
  payAmount,
}: InsuranceInfoProps) => {
  return (
    <InsuranceInfoDiv>
      <InfoIconButton>
        <InfoOutlinedIcon />
      </InfoIconButton>
      {productsWithInsuranceQuantity == 0 ? (
        <InsuranceInfoTypography>
          Tu seguro no cubre ninguno de los productos agregados al carro.
        </InsuranceInfoTypography>
      ) : (
        <InsuranceInfoTypography>
          {orderDetailsAmount == productsWithInsuranceQuantity
            ? 'Todos tus productos tienen cobertura.'
            : productsWithInsuranceQuantity == 1
            ? `
                      ${productsWithInsuranceQuantity} de tus productos tiene cobertura.`
            : `${productsWithInsuranceQuantity} de tus productos tienen cobertura.`}{' '}
          {payAmount != 0
            ? 'Selecciona un método de pago para ver más detalles.'
            : ''}
        </InsuranceInfoTypography>
      )}
    </InsuranceInfoDiv>
  );
};
